export default class BDLProduct {
  constructor(data) {
    this.id = data.id;
    this.codeSupplier = data.codeSupplier;
    this.name = data.name;
    this.packaging = data.packaging;
    this.supplierId = data.supplierId;
    this.bonDeLivraisonId = data.bonDeLivraisonId;
    this.uc = data.uc;
    this.price = data.price;
    this.unit = data.unit;
    this.quantity = data.quantity;
    this.status = data.status;
    this.shopId = data.shopId;
  }

  static get statusTypes() {
    return {
      delivered: 'DELIVERED',
    };
  }

  get statusTypes() {
    return this.constructor.statusTypes;
  }
}
